import { Util } from './util';

export const setLocalStorage = {
  saveToLocalStorage: (key: string, value?: any) => {
    const json = JSON.stringify(value);
    localStorage.setItem(key, json);
  },
  getFromLocalStorage: (key: string) => {
    const jsonBasket = localStorage.getItem(key);
    if (jsonBasket) {
      return JSON.parse(jsonBasket);
    } else {
      return [];
    }
  },
  getFromLocalStorageBoolean: (key: string) => {
    const jsonBasket = localStorage.getItem(key);
    if (jsonBasket) {
      return JSON.parse(jsonBasket);
    } else {
      return null;
    }
  },
};
